import {Flex} from "@aws-amplify/ui-react"
import moment from "moment/moment"
import * as React from "react"
import {useNavigate} from "react-router-dom"
import Api from "../../../../api/graphql/Api"
import {SubscribedActivity, UserSubscription} from "../../../../models"

const SubscribedActivityApi = new Api("SubscribedActivity")

const currentDate = new Date().toISOString()

const getResource = (subscription?: UserSubscription) => {
    switch (true) {
        case !!subscription?.articleId:
            return "an article"
        case !!subscription?.discussionId:
            return "a discussion"
        case !!subscription?.productId:
            return "a product"
        default:
            return "a comment"
    }
}

export default function NotificationMessage({
    notification,
    closeMenu = () => {
    },
    inMenu = false
}: {
    notification: SubscribedActivity,
    closeMenu?: () => void
    inMenu?: boolean
}) {
    const navigate = useNavigate()

    //    const action = notification?.userSubscription?.activityType.toLowerCase() + "d"

    return <Flex
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        gap="0rem"
        grow={ 1 }
        onClick={ () => {
            SubscribedActivityApi
                .runCustomQuery("markAsRead", {
                        input: {
                            id: notification?.id,
                            _version: notification?._version,
                            read: true
                        }
                    }
                )
                .then(() => {
                    closeMenu()
                    navigate(notification?.activity?.url)
                })
        } }
        style={ {
            "width": inMenu === true
                ? "20rem"
                : ""
        } }
    >
        <div
            style={ {
                "fontWeight": "600",
                "textOverflow": "ellipsis",
                "width": "inherit",
                "overflow": "hidden"
            } }
        >
            {/*Someone { action } { resource }*/ }
            New activity on { getResource(notification?.userSubscription) } you follow
        </div>
        <div
            style={ {
                "textOverflow": "ellipsis",
                "width": "inherit",
                "overflow": "hidden"
            } }
        >
            { notification?.activity?.message }
        </div>
        <div style={ {"fontSize": "0.75rem"} }>
            { moment.duration(moment(currentDate)
                .diff(moment(notification.createdAt)))
                .humanize() } ago
        </div>
    </Flex>
}
